<div
  class="layout-container lp-theme-root"
  [attr.data-lp-theme]="themeService.activeTheme()"
>
  <!-- Sidebar Navigation -->
  <aside
    class="sidebar"
    [ngClass]="{
      'open': isSidebarOpen(),
      '!absolute' : isMobile(),
      '!w-0 !p-0': isMobileHide()
    }"
  >
    <!-- Logo Section -->
    <div class="logo-details">
      @if (isSidebarOpen()) {
      <img class="logo_name" src="./images/landing-logo.png" alt="Fan Markazi" />
      }
      <button
        class="toggle-btn"
        (click)="sideBarClose()"
        type="button"
        [attr.aria-label]="isSidebarOpen() ? 'Close sidebar' : 'Open sidebar'"
      >
        <i class="icon-nav" id="btn"></i>
      </button>
    </div>

    <!-- Navigation Menu -->
    <nav class="sidebar-nav">
      @if (isMobile()) {
      <div class="mobile-language">
        <lib-language></lib-language>
      </div>
      }

      <ul class="nav-list">
        @for (item of visibleMenuItems(); track $index) { @if(item?.children) {
        <!-- Menu Item with Children -->
        <li
          class="nav-item has-submenu"
          [ngClass]="{ 'submenu-active': activeSubmenuIndex() === $index }"
        >
          <button
            class="nav-link"
            (click)="setActiveSubmenu($index)"
            type="button"
          >
            <div class="nav-link-content">
              <div class="nav-link-main">
                <i [ngClass]="item.icon"></i>
                <span class="links_name">{{ item.label | transloco }}</span>
              </div>
              <i
                [@rotateAnimation]="activeSubmenuIndex() === $index ? 'rotated' : 'default'"
                class="pi pi-chevron-right chevron-icon links_name"
              ></i>
            </div>
          </button>
          <span class="tooltip">{{ item.label | transloco }}</span>

          <!-- Submenu -->
          <ul
            class="submenu"
            [ngClass]="{ 'opened': activeSubmenuIndex() === $index && isSidebarOpen() }"
          >
            @for (child of item.children; track $index) {
            <li class="submenu-item">
              <a
                [routerLink]="child.link"
                routerLinkActive="activeRoute"
                [routerLinkActiveOptions]="{ exact: child?.exact ?? false }"
                class="submenu-link"
              >
                <span class="links_name">{{ child.label | transloco }}</span>
              </a>
            </li>
            }
          </ul>
        </li>
        } @else {
        <!-- Simple Menu Item -->
        <li class="nav-item">
          <a
            [routerLink]="item.link"
            routerLinkActive="activeRoute"
            class="nav-link"
          >
            <i [class]="item.icon"></i>
            <span class="links_name">{{ item.label | transloco }}</span>
          </a>
          <span class="tooltip">{{ item.label | transloco }}</span>
        </li>
        } }
      </ul>
    </nav>
  </aside>

  <!-- Main Content Area -->
  <main class="main-content">
    <!-- Header -->
    <header class="app-header">
      <div class="header-top">
        @if (!isMobile()) {
        <div class="header-heading">
          <lib-breadcrumb></lib-breadcrumb>
          <!-- Title temporarily hidden from UI -->
          <!-- <h1 class="page-title">{{ activePathName() | transloco }}</h1> -->
        </div>
        } @else {
        <button
          class="mobile-menu-btn"
          (click)="isMobileHide.set(false)"
          type="button"
          aria-label="Open menu"
        >
          <span class="pi pi-align-center"></span>
        </button>
        }

        <div class="header-actions">
          @if (!isMobile()) {
          <lib-fullscreen></lib-fullscreen>
          <lib-language></lib-language>
          }
          <!-- Notification Bell (Commented for future use) -->
          <!-- <div class="notification-wrapper">
            <div class="notification-badge">
              <span class="badge-count">1</span>
            </div>
            <i class="pi pi-bell notification-icon"></i>
          </div> -->
          <lib-user></lib-user>
        </div>
      </div>

      @if (isMobile()) {
      <lib-breadcrumb></lib-breadcrumb>
      }
    </header>

    <!-- Page Content -->
    <div class="page-content">
      <router-outlet></router-outlet>
    </div>
  </main>

  <!-- Mobile Overlay -->
  @if (isMobile() && !isMobileHide()) {
  <div
    class="mobile-overlay"
    (click)="isMobileHide.set(true)"
    role="button"
    tabindex="0"
    aria-label="Close menu"
  ></div>
  }
  <lib-theme-switcher />
</div>
